import * as jsPDF from 'jspdf';
import 'jspdf-autotable';
import QRCode from'davidshimjs-qrcodejs';

function genPdfLinea(detalle, parcialidades, totalLiquidacion, formasPago, conReferencia, fecha, fechav, folio, logo, qrCodi, municipio){
    var doc = new jsPDF({orientation: 'portrait', unit: 'mm',format: 'letter'});
    var color_tem;
    /*var municipio = 'teotihuacan';*/
    if(municipio != null & municipio == 'teotihuacan'){
        color_tem = ['#9D2449',157,36,73];
    }else if(municipio != null & municipio == 'demo'){//216,29,0-D81D00
        color_tem = ['#9D2449',157,36,73];
    }else{
        color_tem = ['#9D2449',157,36,73];
    }

    if(conReferencia){
        doc.setFontSize(16);
        doc.setFontType("bold");
        doc.text("FORMATO DE PAGO REFERENCIADO", 100, 22);
        doc.setFontType("normal");

        var imgData = 'data:image/jpeg;base64,' + logo;
        doc.addImage(imgData, 'JPEG', 15, 4, 60, 30);
        doc.setFillColor(color_tem[1],color_tem[2],color_tem[3]);
        doc.rect(14, 35, 189, 0.7, 'F');

        doc.setDrawColor(color_tem[1],color_tem[2],color_tem[3]);
        doc.setLineWidth(0.7);
        doc.rect(125, 40, 78, 31);
        doc.setFontSize(16);
        doc.setTextColor(0,0,0);
        doc.text("Serie: ", 150, 47, 'right');
        doc.setFontType("bold");
        doc.text(folio.substring(0,3), 163, 47, 'right');
        doc.setFontType("normal");
        doc.text("Folio: ", 182, 47, 'right');
        doc.setFontType("bold");
        doc.text(folio.substring(3,9), 200, 47, 'right');
        doc.setFontType("normal");

        doc.setFontSize(12);
        doc.text("Válido hasta: " + fechav, 200, 53, 'right');
    }

    doc.setFontSize(18);
    doc.text("Total a Pagar:", 199, 61, 'right');
    doc.setTextColor(160,2,24);
    doc.text("$"+totalLiquidacion, 200, 68, 'right');
    doc.setTextColor(0,0,0);

    doc.setFillColor(0,0,0);
    doc.setFontSize(16);
    doc.autoTable({
        styles: {fillColor:'#FFFFFF',textColor:'#000000', font:'helvetica', fontStyle: 'bold', halign: 'center', lineWidth: 0.6, lineColor:[color_tem[1],color_tem[2],color_tem[3]]},
        theme:'plain',
        headStyles:{fillColor:color_tem[0], textColor:'#FFFFFF'},
        bodyStyles: {fillColor:'#FFFFFF', cellPadding:{top: 2, right: 2, bottom: 2, left: 2}},
        startY:40,
        tableWidth: 101,
        margin: {top: 20},
        head: [['Datos del Pago']],
        body: [[detalle]],
        columnStyles: {0: {halign: 'center'}}
    });

    /* Cálculo del total de Páginas */
    var totalPag = 1;
    if(parcialidades.length > 14 && parcialidades.length < 24){
        totalPag ++;
    }else if(parcialidades.length >= 24 && parcialidades.length <= 45){
        totalPag ++;
    }else if(parcialidades.length > 45){
        totalPag=totalPag+2;
    }
    doc.setFillColor(color_tem[1],color_tem[2],color_tem[3]);
    doc.rect(14, 270, 189, 0.7, 'F');
    doc.setFontSize(7);
    if(fecha != null){
        doc.text("Fecha y hora de generación: "+fecha, 15, 273);
    }
    doc.text("Página 1 de " + totalPag, 187, 273);

    doc.setFontType("bold");
    doc.setFontSize(16);
    doc.text("Liquidación", 105, 85, 'center');
    doc.setFontType("normal");
    doc.autoTable({
        styles: {textColor:'#000000', font: 'helvetica',fontStyle: 'bold', halign: 'center'},
        headStyles:{fillColor:color_tem[0], textColor:'#FFFFFF'},
        bodyStyles: {fillColor:'#FFEBF1'},
        startY:87,
        margin: {top: 20},
        head: [['Periodo','Importe','Recargo','Multa','Pae','Subsidios','Total']],
        body: parcialidades,
        columnStyles: {0: {halign: 'center'}} 
    });

    if(conReferencia){

        /* Cálculo del eje 'Y' en función del número de parcialidades */
        var ejeY = 112 + ((parcialidades.length)*7);
        if(parcialidades.length > 14 && parcialidades.length < 24){
            doc.addPage();
            doc.setFillColor(0,0,0);
            doc.rect(14, 270, 189, 0.7, 'F');
            doc.setFontSize(7);
            doc.text("Fecha y hora de generación: "+fecha, 15, 273);
            doc.text("Página 2 de " + totalPag, 187, 273);
            ejeY = 15;
            totalPag ++;
        }else if(parcialidades.length >= 24 && parcialidades.length <= 45){
            doc.setFillColor(0,0,0);
            doc.rect(14, 270, 189, 0.7, 'F');
            doc.setFontSize(7);
            doc.text("Fecha y hora de generación: "+fecha, 15, 273);
            doc.text("Página 2 de " + totalPag, 187, 273);
            ejeY = 43 + ((parcialidades.length-22)*7);
        }else if(parcialidades.length > 45 && parcialidades.length < 55){
            doc.setFillColor(0,0,0);
            doc.rect(14, 270, 189, 0.7, 'F');
            doc.setFontSize(7);
            doc.text("Fecha y hora de generación: "+fecha, 15, 273);
            doc.text("Página 2 de " + totalPag, 187, 273);
            doc.addPage();
            doc.rect(14, 270, 189, 0.7, 'F');
            doc.text("Fecha y hora de generación: "+fecha, 15, 273);
            doc.text("Página 3 de " + totalPag, 187, 273);
            ejeY = 15;
        }else if(parcialidades.length >= 55){
            doc.setPage(2);
            doc.setFillColor(0,0,0);
            doc.rect(14, 270, 189, 0.7, 'F');
            doc.setFontSize(7);
            doc.text("Fecha y hora de generación: "+fecha, 15, 273);
            doc.text("Página 2 de " + totalPag, 187, 273);
            doc.setPage(3);
            doc.setFillColor(0,0,0);
            doc.rect(14, 270, 189, 0.7, 'F');
            doc.setFontSize(7);
            doc.text("Fecha y hora de generación: "+fecha, 15, 273);
            doc.text("Página 3 de " + totalPag, 187, 273);
            ejeY = 50 + ((parcialidades.length-53)*7);
        }

        /*var qrCodi = "informacion de ejemplo";*/
        var widthTableFormasPago='auto';
        if(qrCodi != null){
            doc.setFontType("bold");
            doc.setFontSize(16);
            doc.text("CoDi", 179, ejeY+8, 'center');
            doc.setFontSize(9);
            doc.text("Paga desde tu celular", 179, ejeY+11,'center');
            var divQr = document.createElement("div");
            new QRCode(divQr, qrCodi);
            const src = divQr.children[0].toDataURL("image/png");
            doc.setDrawColor(0,0,0);
            doc.setLineWidth(0.6);
            doc.rect(158, ejeY+2, 43, 60);
            doc.addImage(src,'PNG', 160.10, ejeY+13, 38.85, 40);
            doc.text("Escanea desde tu", 179, ejeY+57,'center');
            doc.text("aplicación bancaría", 179, ejeY+60,'center');
            widthTableFormasPago=134;
        }

        doc.setFontSize(16);
        doc.text("Formas de Pago", 105, ejeY,'center');
        doc.setFontType("normal");
        ejeY = ejeY + 2;
        doc.setFontSize(12);
        doc.autoTable({
            styles: {textColor:'#000000', font: 'helvetica',fontStyle: 'bold', lineWidth: 0.6, lineColor:[color_tem[1],color_tem[2],color_tem[3]]},
            theme:'plain',
            bodyStyles: {fillColor:'#FFFFFF', cellPadding:{top: 3, right: 3, bottom: 2.5, left: 3}},
            headStyles:{fillColor:color_tem[0], textColor:'#FFFFFF',halign: 'center'},
            tableWidth: widthTableFormasPago,
            startY:ejeY,
            margin: {top: 20},
            head: [['Forma de Pago']],
            body: formasPago,
            columnStyles: {0: {halign: 'left'}}
        });
    }

    return URL.createObjectURL(doc.output('blob'));
}

function genPdfReciboCobro(logo, folio, serie, emisor, contacto, fechaHora, nombre, descripcion, liquidacion, totalLetra, usuario, cadenaVerificadora){
    var doc = new jsPDF({orientation: 'portrait', unit: 'mm',format: [289.875, 71.614]});
    var imgData = 'data:image/jpeg;base64,' + logo;
    doc.addImage(imgData, 'JPEG', 6, 5, 60, 30);

    doc.setFontSize(12);
    doc.setFontType("bold");
    doc.text("RECIBO OFICIAL", 17, 42);
    doc.setFontType("normal");
    var ejeY = 47;

    /* serie + folio */
    doc.setFontSize(12);
    var serieFolio = doc.splitTextToSize(serie + folio, 50);
    doc.text(serieFolio, 32 , ejeY, 'center');
    ejeY=ejeY+5;

    /* emisor */
    doc.setFontSize(9);
    var splitEmisor = doc.splitTextToSize(emisor, 60);
    doc.text(splitEmisor, 34, ejeY, 'center');
    if(emisor.length < 23){
        ejeY=ejeY+5;
    }else{
        ejeY=ejeY+10;
    }

    /* contacto */
    var splitContacto = doc.splitTextToSize(contacto, 60);
    doc.text(splitContacto, 34, ejeY, 'center');
    if(contacto.length < 32){
        ejeY=ejeY+5;
    }else if(contacto.length < 56){
        ejeY=ejeY+10;
    }else{
        ejeY=ejeY+15;
    }

    /* fecha y hora */
    doc.setFontSize(9);
    var splitFecha = doc.splitTextToSize("Fecha y hora del cobro: "+fechaHora, 60);
    doc.text(splitFecha, 33, ejeY, 'center');
    ejeY=ejeY+10;

    /* Nombre */
    doc.setFontSize(10);
    var splitNombre = doc.splitTextToSize("Contribuyente: "+nombre, 60);
    doc.text(splitNombre, 33, ejeY, 'center');
    ejeY=ejeY+15;

    doc.text("DATOS DEL PAGO", 15, ejeY);
    ejeY=ejeY+2;
    doc.setFillColor(0,0,0);
    doc.rect(3, ejeY, 65, 1, 'F');
    ejeY=ejeY+5;

    /* descripcion */
    var descReplace = descripcion.replace(/¬/gi, function () {
        return "\r\n";
    });
    var splitDesc = doc.splitTextToSize(descReplace, 60);
    doc.text(splitDesc, 3, ejeY, 'left');

    if(descripcion.length < 135){
        ejeY=ejeY+30;
    }else if(descripcion.length < 203){
        ejeY=ejeY+40;
    }else if(descripcion.length < 271){
        ejeY=ejeY+50;
    }else if(descripcion.length < 339){
        ejeY=ejeY+60;
    }else{
        ejeY=ejeY+80;
    }

    /* liquidacion */
    var liqReplace = liquidacion.replace(/¬/gi, function () {
        return "\r\n";
    });
    var splitLiq = doc.splitTextToSize(liqReplace, 60);
    doc.text(splitLiq, 3, ejeY, 'left');
    if(liquidacion.length < 90){
        ejeY=ejeY+20;
    }else if(liquidacion.length < 136){
        ejeY=ejeY+35;
    }else if(liquidacion.length < 181){
        ejeY=ejeY+50;
    }else if(liquidacion.length < 225){
        ejeY=ejeY+60;
    }else{
        ejeY=ejeY+100;
    }
    
    /* total */
    doc.text(totalLetra, 50, ejeY);
    ejeY=ejeY+3;

    doc.rect(3, ejeY, 65, 1, 'F');
    ejeY=ejeY+5;

    /* usuario */
    var splitUsuario = doc.splitTextToSize("Nombre del cajero (a): " + usuario, 60);
    doc.text(splitUsuario, 34, ejeY, 'center');
    ejeY=ejeY+11;

    /* cadena de verificacion */
    doc.text("Cadena de verificacion", 33, ejeY, 'center');
    ejeY=ejeY+4;
    var splitCadena = doc.splitTextToSize(cadenaVerificadora, 60);
    doc.text(splitCadena, 35, ejeY, 'center');
    ejeY=ejeY+60;

    /* fin del recibo */
    doc.text("'*****Fin del recibo*****'", 13, ejeY);

    return URL.createObjectURL(doc.output('blob'));
}


function genPdfOrden(municipio, fecha, usuario, detalle, total, idElementBarcode, folio, logo){
    var doc = new jsPDF({orientation: 'portrait', unit: 'mm',format: [210, 48]});
    var imgData = 'data:image/jpeg;base64,' + logo;
    doc.addImage(imgData, 'JPEG', 3.7, 2, 40, 20);
    doc.setFontSize(9);
    var splitTitle = doc.splitTextToSize("MUNICIPIO DE "+municipio, 46);
    doc.text(splitTitle, 1, 26);
    doc.text(fecha, 1, 34);//8
    doc.text("EMITIDO POR:", 1, 39);//5
    doc.text(usuario, 1, 44);//5

    var canvas = document.getElementById(idElementBarcode);
    var jpegUrl = canvas.toDataURL();
    doc.addImage(jpegUrl, 'PNG', 0, 46, 47, 45);//2
    doc.text(folio, 23, 93, 'center');//47

    doc.setFontSize(10);
    doc.text("TOTAL A PAGAR:", 1, 101);//8
    doc.setFontSize(12);
    doc.text("$"+total, 1, 106)//5

    doc.setFontSize(9);
    var splitTitle2 = doc.splitTextToSize(detalle, 46);
    doc.text(splitTitle2, 1, 111);//5
    
    /* Se comentó que habria un parametro fecVencimiento y se cambiará por la siguiente leyenda*/
    var splitTitle3 = doc.splitTextToSize("ESTA ORDEN DE PAGO SOLO ES VÁLIDA PARA EL MES EN QUE SE EMITE", 46);
    doc.text(splitTitle3, 1, 146);//35

    return URL.createObjectURL(doc.output('blob'));
}

function generateCFDI(){/* La parte de Qrcode esta comentada, si se necesita usar esta función es necesario descomentarlo e importar la libreria 'davidshimjs-qrcodejs' */
    var doc = new jsPDF('p','mm','letter');

    var text, parser, xmlDoc;
    text = "<?xml version='1.0' encoding='utf-8' standalone='yes'?><cfdi:Comprobante Version='3.3' Serie='KP' Folio='006350' Fecha='2020-04-02T10:54:16' Sello='mmmjuHrr23qvJ6dGaixeF3afRG1m+mXXV8iJEouKoJxWFLb9Q6RTF2SWTgrgGufr6dazCN+37Ram2y+vDsMfDDDAt+xvIROWC0NkJMr0SvLgVpt3/CuR8jHZIIe3O2B0F0CF5SAYIpepNzC6uqmhIBVepXg6drX5fKD5Q6IZI/Y3eqqrGrpC16Tr/RPoTs/Alr2MegPn/iKrPL0LPrvd8bZfeA+a473ggVafk8cptA2pwHh7z0CxuzchImgs4gv8uDs8OHvpCxdmY9yB1n1KJGPPhpM7kJRF3wZzu19HOhNIey8ZqpIiykaoxxyqLThpU2cQmqfd8RhD5srHXyMAfw==' FormaPago='01' NoCertificado='00001000000501278771' Certificado='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' SubTotal='889.00' Moneda='MXN' Total='889.00' TipoDeComprobante='I' MetodoPago='PUE' LugarExpedicion='55800' xsi:schemaLocation='http://www.sat.gob.mx/cfd/3 http://www.sat.gob.mx/sitio_internet/cfd/3/cfdv33.xsd' xmlns:nomina12='http://www.sat.gob.mx/nomina12' xmlns:tfd='http://www.sat.gob.mx/TimbreFiscalDigital' xmlns:cfdi='http://www.sat.gob.mx/cfd/3' xmlns:xsi='http://www.w3.org/2001/XMLSchema-instance'> <cfdi:Emisor Rfc='MTE7901014X1' Nombre='MUNICIPIO DE TEOTIHUACAN' RegimenFiscal='603'/> <cfdi:Receptor Rfc='XAXX010101000' Nombre='ARTURO MORALES LIMA' UsoCFDI='G03'/> <cfdi:Conceptos> <cfdi:Concepto ClaveProdServ='93161700' NoIdentificacion='4112-01-02-01-00' Cantidad='1' ClaveUnidad='C62' Unidad='ACT' Descripcion='IMPUESTO PREDIAL¬Clave:0891611504000000¬Ubicación del predio:JIMENEZ CANTU LT.5 MZA. 6 NUEVA TEOTIHUACAN¬Valor catastral:629.124,00¬Año del avalúo:2020¬Superficie terreno propio:1.142,00¬Superficie construcción propia:140,00¬Tipo de uso:HABITACIONAL¬Notificado:NO¬No. de actos:0¬Fecha de pago: 02/04/2020 10:53:58¬' ValorUnitario='889.00' Importe='889.00'> <cfdi:CuentaPredial Numero='0891611504000000'/> </cfdi:Concepto> </cfdi:Conceptos> <cfdi:Complemento> <tfd:TimbreFiscalDigital Version='1.1' SelloSAT='tY7VK/DG2W+s/RuPKXEeWfat1BomCWhm/pctZ4BpktZYhaCj615+Vf4bQYGVWbI4SWxMwfcTQVK65mzPsI2rjIv6CLl+1SCGL+Unn7XRzD7qTggkIiph0SkFM4QKDb/b3YJ+nU5BSXy6MED6eEFsUOwqo1o9VY9nnfdtEzIrqj9A3k761XfTKRrI7TuU6/1YjBPhLdJVU0f5tTPghyYodLJE58wVGTHsfLnHTjwWmGk6KPRlYMGLCWA6o/zykT9o62oPU92ZSDIrrpa6IGoF62ElpE7osC4T1wwxYvXIaUCq4ASCi144Or8T++8zyhcS3eVmMbmE9w0uKYPpKOwzyA==' NoCertificadoSAT='00001000000403190844' SelloCFD='mmmjuHrr23qvJ6dGaixeF3afRG1m+mXXV8iJEouKoJxWFLb9Q6RTF2SWTgrgGufr6dazCN+37Ram2y+vDsMfDDDAt+xvIROWC0NkJMr0SvLgVpt3/CuR8jHZIIe3O2B0F0CF5SAYIpepNzC6uqmhIBVepXg6drX5fKD5Q6IZI/Y3eqqrGrpC16Tr/RPoTs/Alr2MegPn/iKrPL0LPrvd8bZfeA+a473ggVafk8cptA2pwHh7z0CxuzchImgs4gv8uDs8OHvpCxdmY9yB1n1KJGPPhpM7kJRF3wZzu19HOhNIey8ZqpIiykaoxxyqLThpU2cQmqfd8RhD5srHXyMAfw==' RfcProvCertif='CVD110412TF6' FechaTimbrado='2020-04-02T10:54:17' UUID='74C913CF-66CA-4CA4-9EDB-0B5D92119F43'/> </cfdi:Complemento> <cfdi:Addenda>Periodo: enero-diciembre 2020¬Importe: 878,16 Recargo: 10,84 SubTotal *** 889,00¬¬Total *** $ 889,00 ***</cfdi:Addenda> </cfdi:Comprobante>";
    parser = new DOMParser();
    xmlDoc = parser.parseFromString(text,"text/xml");


    var nombreEmisor = xmlDoc.getElementsByTagName("cfdi:Emisor")[0].getAttribute("Nombre");
    var rfcEmisor = xmlDoc.getElementsByTagName("cfdi:Emisor")[0].getAttribute("Rfc");
    var nombreReceptor = xmlDoc.getElementsByTagName("cfdi:Receptor")[0].getAttribute("Nombre");
    var rfcReceptor = xmlDoc.getElementsByTagName("cfdi:Receptor")[0].getAttribute("Rfc");
    var serie = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("Serie");
    var folio = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("Folio");
    var uuid = xmlDoc.getElementsByTagName("tfd:TimbreFiscalDigital")[0].getAttribute("UUID");
    var datosPago = xmlDoc.getElementsByTagName("cfdi:Addenda")[0].textContent; 
    var conceptos = xmlDoc.getElementsByTagName("cfdi:Concepto");
    var subTotal = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("SubTotal");
    var total = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("Total");
    var moneda = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("Moneda");
    var fecha = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("Fecha");
    var fechaTimbrado = xmlDoc.getElementsByTagName("tfd:TimbreFiscalDigital")[0].getAttribute("FechaTimbrado");
    var csd = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("NoCertificado");
    var lugarExpedicion = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("LugarExpedicion");
    var noCertificadoSAT = xmlDoc.getElementsByTagName("tfd:TimbreFiscalDigital")[0].getAttribute("NoCertificadoSAT");
    var selloCfdi = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("Sello");
    var selloSAT = xmlDoc.getElementsByTagName("tfd:TimbreFiscalDigital")[0].getAttribute("SelloSAT");
    var claveProdServ = xmlDoc.getElementsByTagName("cfdi:Concepto")[0].getAttribute("ClaveProdServ");
    var noIdentificacion = xmlDoc.getElementsByTagName("cfdi:Concepto")[0].getAttribute("NoIdentificacion");
    var tipoDeComprobante = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("TipoDeComprobante");
    var regimenFiscal = xmlDoc.getElementsByTagName("cfdi:Emisor")[0].getAttribute("RegimenFiscal");
    var usoCFDI = xmlDoc.getElementsByTagName("cfdi:Emisor")[0].getAttribute("UsoCFDI");
    var metodoPago = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("MetodoPago");
    var formaPago = xmlDoc.getElementsByTagName("cfdi:Comprobante")[0].getAttribute("FormaPago");

    var arrayConceptos = [];
    for(var idx = 0; idx < conceptos.length; idx++){
        arrayConceptos[idx] = [conceptos[idx].getAttribute("Cantidad"), conceptos[idx].getAttribute("Unidad"), conceptos[idx].getAttribute("ValorUnitario"), conceptos[idx].getAttribute("Importe"), conceptos[idx].getAttribute("Descripcion")];
    }
    
    doc.setFillColor(220,221,222);
    doc.rect(15, 10, 90, 8,'F');
    doc.setFontSize(12);
    doc.text("FACTURA ELECTRONICA (CFDI)", 28, 16, null, null,'left');
    doc.setFontSize(10);

    /*Datos del emisor*/
    doc.text("Datos del Emisor", 16, 25, null, null,'left');
    nombreEmisor = doc.splitTextToSize(nombreEmisor, 90);
    doc.text(nombreEmisor, 16, 30, null, null,'left');
    doc.text(rfcEmisor, 16, 38, null, null,'left');
    doc.text(regimenFiscal, 16, 42, null, null,'left');//Personas morales con fines no lucrativos

    /*Datos del emisor*/
    doc.text("Datos del receptor", 16, 52, null, null,'left');
    nombreReceptor = doc.splitTextToSize(nombreReceptor, 90);
    doc.text(nombreReceptor, 16, 57, null, null,'left');
    doc.setFontSize(9);
    doc.text(rfcReceptor, 16, 66, null, null,'left');
    doc.text("Uso del CFDI: " + usoCFDI, 16, 70, null, null,'left');

    /*Serie y folio*/
    doc.setFontSize(11);
    doc.text("Serie: " + serie + " Folio: " + folio, 120, 16, null, null,'left');
    doc.setFontSize(10);
    doc.text("Folio fiscal:", 120, 21, null, null,'left');
    doc.text(uuid, 120, 26, null, null,'left');
    doc.text("Tipo de comprobante: " + tipoDeComprobante, 120, 31, null, null,'left');

    /*Código QR*/
    var divQr = document.createElement("div");
    //new QRCode(divQr, "qrCfdi");
    const src = divQr.children[0].toDataURL("image/png");
    doc.addImage(src,'PNG', 120, 34, 34, 34);

    var numPag = 1;
    doc.text("Página " + numPag, 170, 45, null, null,'left');
    

    /*Datos del pago*/
    doc.setFontSize(12);
    doc.text("DATOS DEL PAGO", 88, 76, null, null,'left');

    doc.setFillColor(0,0,0);
    doc.rect(15, 78, 182, 1,'F');

    doc.setFontSize(8);
    datosPago = datosPago.replace(/¬/g, '\n');
    doc.text(datosPago, 16, 84, null, null,'left');

    var ejeYConceptos = 97;
    var ejeYDescription = 84;
    var puntoInicioDivisor = 80;
    var heightDivisor = 45;

    for(var idxConceptos = 0; idxConceptos < 1; idxConceptos++){
        doc.text("Cantidad:", 16, ejeYConceptos, null, null,'left');
        doc.text(arrayConceptos[0][0], 90, ejeYConceptos, null, null,'right');
        ejeYConceptos = ejeYConceptos + 3;

        doc.text("Unidad:", 16, ejeYConceptos, null, null,'left');
        doc.text(arrayConceptos[0][1], 90, ejeYConceptos, null, null,'right');
        ejeYConceptos = ejeYConceptos + 3;

        doc.text("Valor unitario:", 16, ejeYConceptos, null, null,'left');
        doc.text(arrayConceptos[0][2], 90, ejeYConceptos, null, null,'right');
        ejeYConceptos = ejeYConceptos + 3;

        doc.text("Importe:", 16, ejeYConceptos, null, null,'left');
        doc.text(arrayConceptos[0][3], 90, ejeYConceptos, null, null,'right');
        ejeYConceptos = ejeYConceptos + 8;

        doc.text("Forma de pago :", 16, ejeYConceptos, null, null,'left');
        doc.text(formaPago, 90, ejeYConceptos, null, null,'right');//texto fijo
        ejeYConceptos = ejeYConceptos + 3;

        doc.text("Método de pago:", 16, ejeYConceptos, null, null,'left');
        doc.text(metodoPago, 90, ejeYConceptos, null, null,'right');//texto fijo
        ejeYConceptos = ejeYConceptos + 10;

        var descripcion = arrayConceptos[0][4].replace(/¬/g, '\n');
        descripcion = doc.splitTextToSize(descripcion, 90);
        doc.text(descripcion, 108, ejeYDescription, null, null,'left');
        ejeYDescription = ejeYDescription + 40;

        doc.text("Clave del producto o servicio: " + claveProdServ, 108, ejeYDescription, null, null,'left');
        ejeYDescription = ejeYDescription + 3;

        doc.text("No. de identificación: " + noIdentificacion, 108, ejeYDescription, null, null,'left');

        ejeYDescription = ejeYDescription + 8;
        heightDivisor = heightDivisor + 35;

        doc.setFillColor(0,0,0);
        doc.rect(105, puntoInicioDivisor, 0.5, heightDivisor,'F');

        //alert(ejeYDescription); && idx < 2
        if(ejeYDescription >= 230){
            doc.addPage();
            numPag++;
            puntoInicioDivisor = 8;
            heightDivisor = 50;
            ejeYDescription = 10;
            ejeYConceptos = 10;
        }
    }

    var ejeY = numPag > 1 ? heightDivisor + 10 : heightDivisor + 80;//Es igual al punto en el eje Y donde se debe continuar
    ejeYConceptos = ejeYConceptos + 3;

    if(ejeYConceptos > 255){
        doc.addPage();
        numPag++;
        ejeYConceptos = 10;
        ejeY = 16;
    }

    doc.text("SubTotal:", 16, ejeYConceptos, null, null,'left');
    doc.text(subTotal, 90, ejeYConceptos, null, null,'right');
    ejeYConceptos = ejeYConceptos + 3;
    doc.text("Total:" + moneda, 16, ejeYConceptos, null, null,'left');
    doc.text(total, 90, ejeYConceptos, null, null,'right');

    if(ejeY > 250){
        doc.addPage();
        numPag++;
        ejeY = 10;
    }
    ejeY = ejeY + 2;
    doc.rect(15, ejeY, 182, 1,'F');

    doc.setFontSize(7);
    ejeY = ejeY + 6;
    if(ejeY > 250){
        doc.addPage();
        numPag++;
        ejeY = 10;
    }
    doc.text("Fecha de emisión: " + fecha, 16, ejeY, null, null,'left');
    doc.text("No. de certificado del CSD: " + csd, 75, ejeY, null, null,'left');
    doc.text("Lugar de emisión: " + lugarExpedicion, 150, ejeY, null, null,'left');
    ejeY = ejeY + 4;
    if(ejeY > 250){
        doc.addPage();
        numPag++;
        ejeY = 10;
    }
    doc.text("Fecha de certificación: " + fechaTimbrado, 16, ejeY, null, null,'left');
    doc.text("No. de certificado SAT: " + noCertificadoSAT, 75, ejeY, null, null,'left');

    ejeY = ejeY + 6;
    if(ejeY > 250){
        doc.addPage();
        numPag++;
        ejeY = 10;
    }
    doc.text("Sello digital del CFDI:", 16, ejeY, null, null,'left');
    selloCfdi = doc.splitTextToSize(selloCfdi, 180);
    ejeY = ejeY + 3;
    doc.text(selloCfdi, 16, ejeY, null, null,'left');

    ejeY = ejeY + 13;
    if(ejeY > 250){
        doc.addPage();
        numPag++;
        ejeY = 10;
    }
    doc.text("Sello SAT:", 16, ejeY, null, null,'left');
    selloSAT = doc.splitTextToSize(selloSAT, 180);
    ejeY = ejeY + 3;
    doc.text(selloSAT, 16, ejeY, null, null,'left');

    ejeY = ejeY + 13;
    if(ejeY > 245){
        doc.addPage();
        numPag++;
        ejeY = 10;
    }
    doc.text("Cadena original del complemento de certificación del SAT:", 16, ejeY, null, null,'left');
    ejeY = ejeY + 3;
    var cadenaSat = "||1.1|74C913CF-66CA-4CA4-9EDB-0B5D92119F43|2020-04-02T10:54:17|mmmjuHrr23qvJ6dGaixeF3afRG1m+mXXV8iJEouKoJxWFLb9Q6RTF2SWTgrgGufr6dazCN+37Ram2y+vDsMfDDDAt+xvIROWC0NkJMr0SvLgVpt3/CuR8jHZIIe3O2B0F0CF5SAYIpepNzC6uqmhIBVepXg6drX5fKD5Q6IZI/Y3eqqrGrpC16Tr/RPoTs/Alr2MegPn/iKrPL0LPrvd8bZfeA+a473ggVafk8cptA2pwHh7z0CxuzchImgs4gv8uDs8OHvpCxdmY9yB1n1KJGPPhpM7kJRF3wZzu19HOhNIey8ZqpIiykaoxxyqLThpU2cQmqfd8RhD5srHXyMAfw==|00001000000403190844||";
    cadenaSat = doc.splitTextToSize(cadenaSat, 180);
    doc.text(cadenaSat, 16, ejeY, null, null,'left');

    ejeY = ejeY + 15;
    doc.setFontSize(9);
    doc.text("Este documento es una representación impresa de un CFDI", 70, ejeY, null, null,'left');

    doc.save("test.pdf");
}

function navTo(destino){
    var isLarge = document.documentElement.clientWidth >= 992;
    var offsetY = null;
    if(destino == 'liqform'){
        offsetY = isLarge ? -1000000 : 1000000;
    }else if(destino == 'liqtable'){
        offsetY = isLarge ? 500 : 1000000;
    }else if(destino == 'formastable'){
        offsetY = isLarge ? 300 : 1000000;
    }
    if(offsetY != null){
        window.setTimeout(function(){window.scrollBy(0, offsetY);}, 500);
    }
}

function generarTxtFile(nombre, contenido, tipo){
    var linkDownload = document.createElement("a");
    linkDownload.setAttribute('href', 'data:text/plain;base64,'+encodeURIComponent(contenido));
    linkDownload.setAttribute('download', nombre +'.'+tipo);
    linkDownload.style.display = 'none';
    document.body.appendChild(linkDownload);
    linkDownload.click();
    document.body.removeChild(linkDownload);
}
function generarTxtFileUtf8(nombre, contenido, tipo){
    var linkDownload = document.createElement("a");
    linkDownload.setAttribute('href', 'data:text/plain;charset=utf-8,' + encodeURIComponent(contenido));
    linkDownload.setAttribute('download', nombre +'.'+tipo);
    linkDownload.style.display = 'none';
    document.body.appendChild(linkDownload);
    linkDownload.click();
    document.body.removeChild(linkDownload);
}

function downloadB64Pdf(b64, nombre){
    var downloadPdf = document.createElement('a');
    downloadPdf.setAttribute('href', "data:application/pdf;base64," + b64);
    downloadPdf.setAttribute('download', nombre+".pdf");
    downloadPdf.click();
}

function getBase64(f, store){
    let reader = new FileReader();
    // Closure to capture the file information.
    reader.onload = (function() {
        return function(theFile) {
        let binaryData = theFile.target.result;
        // Convertir datos binarios a base 64
        let base64String = window.btoa(binaryData);
        // mostrando el archivo convertido a base64
        let tipo = f.name.split('.').pop();
        store.commit("updateArchivoB64", {contenido:base64String, nombre:f.name, tipo:tipo});
        };
    })(f);
    // Read in the image file as a data URL.
    reader.readAsBinaryString(f);
}

function convertUTMToLatLon(E, N, zone) {
      const a = 6378137.0; // Radio del ecuador WGS84
      const e = 0.0818191908;
      const k0 = 0.9996;

      let x = E - 500000.0;
      let y = N;

      const m = y / k0;
      const mu = m / (a * (1 - Math.pow(e, 2) / 4 - 3 * Math.pow(e, 4) / 64 - 5 * Math.pow(e, 6) / 256));

      const e1 = (1 - Math.sqrt(1 - e * e)) / (1 + Math.sqrt(1 - e * e));

      const J1 = (3 * e1) / 2 - (27 * Math.pow(e1, 3)) / 32;
      const J2 = (21 * Math.pow(e1, 2)) / 16 - (55 * Math.pow(e1, 4)) / 32;
      const J3 = (151 * Math.pow(e1, 3)) / 96;
      const J4 = (1097 * Math.pow(e1, 4)) / 512;

      const fp =
        mu +
        J1 * Math.sin(2 * mu) +
        J2 * Math.sin(4 * mu) +
        J3 * Math.sin(6 * mu) +
        J4 * Math.sin(8 * mu);

      const C1 = Math.pow(e, 2) * Math.pow(Math.cos(fp), 2) / (1 - e * e);
      const T1 = Math.pow(Math.tan(fp), 2);
      const R1 = a * (1 - e * e) / Math.pow(1 - Math.pow(e * Math.sin(fp), 2), 3 / 2);
      const N1 = a / Math.sqrt(1 - Math.pow(e * Math.sin(fp), 2));

      const D = x / (N1 * k0);

      const lat =
        fp -
        (N1 * Math.tan(fp) / R1) *
          (D * D / 2 -
            (5 + 3 * T1 + 10 * C1 - 4 * C1 * C1 - 9 * (e * e / (1 - e * e))) *
              Math.pow(D, 4) /
              24 +
            (61 + 90 * T1 + 298 * C1 + 45 * T1 * T1 - 252 * (e * e / (1 - e * e)) - 3 * C1 * C1) *
              Math.pow(D, 6) /
              720);

      const lon =
        (D -
          (1 + 2 * T1 + C1) * Math.pow(D, 3) / 6 +
          (5 - 2 * C1 + 28 * T1 - 3 * C1 * C1 + 8 * (e * e / (1 - e * e)) + 24 * T1 * T1) *
            Math.pow(D, 5) /
            120) /
          Math.cos(fp) +
        ((zone - 1) * 6 - 180 + 3) * (Math.PI / 180);

      return {
        lat: (lat * 180) / Math.PI,
        lon: (lon * 180) / Math.PI
      };
    }

export { navTo, genPdfOrden, genPdfLinea, generateCFDI, genPdfReciboCobro, downloadB64Pdf, generarTxtFile, generarTxtFileUtf8, getBase64, convertUTMToLatLon };